export default __webpack_public_path__ + "static/media/lessThan.d9be659c.svg";